import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  TouchableOpacity,
  View,
  Text,
  Image,
  Dimensions,
} from "react-native";
import useAuth from "../auth/useAuth";
import AppText from "../components/AppText";
import { BinaryAlert } from "../components/CustomAlert";
import CommonFooter from "../components/CommonFooter";
import Screen from "../components/Screen";
import colors from "../config/colors";
import useApi from "../hooks/useApi";
import ActivityIndicator from "../components/ActivityIndicator";
import storage from "../auth/storage";
import questions from "../api/questions";

function HomeScreen({ navigation, route }) {
  const [record_id, setRecordId] = useState();
  const singleSubmissionApi = useApi(questions.getSubmission);
  const { logOut } = useAuth();
  const onNewReport = () => {
    navigation.navigate("Migrate");
  };
  const onPreviousReports = () => {
    navigation.navigate("Entries");
  };
  const onEditProfile = () => {
    navigation.navigate("Edit");
  };

  const onLogout = () => {
    BinaryAlert(
      "Logout",
      "Are you sure you want to logout?",

      () => logOut(),
      () => console.log("Cancel Pressed")
    );
    // logOut();
  };

  useEffect(() => {
    let submission_id = new URLSearchParams(window.location.search).get(
      "submission_id"
    );
    setRecordId(submission_id);
    // console.log(submission_id, "dksjdkas");
    if (submission_id) {
      // async function getSingleS() {
      // console.log(submission_id, "djsakds");
      //   const token = storage.getToken();
      //   const result = await singleSubmissionApi.request(submission_id, token);
      //   console.log(result.data, "dklsj");
      navigation.navigate("Final", {
        submission_id_redirect: submission_id,
        payment_redirect: true,
      });
      // window.location.href = window.location.pathname.slice(
      //   0,
      //   window.location.pathname.lastIndexOf("/")
      // );
      // }
      // getSingleS();
    } else {
      console.log("no_sub", "djsakds");
    }
    return () => {};
  }, [record_id]);

  // if (window.location.href.includes("success.php")) {
  //   navigation.navigate("Final", { paySuccess: window.location.href });
  // }

  return (
    <Screen style={{ justifyContent: "center" }}>
      <Image
        source={require("../assets/paris_portrait.jpg")}
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          // resizeMode: "contain",
        }}
      />
      <View
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          backgroundColor: colors.skyBlueTrans,
          // resizeMode: "contain",
        }}
      ></View>
      <ActivityIndicator visible={singleSubmissionApi.loading} />
      <Image
        source={require("../assets/human.png")}
        style={{
          width: 80,
          height: 80,
          alignSelf: "center",
          top: 20,
          marginBottom: 20,
        }}
      />
      <View>
        <AppText
          style={{
            marginHorizontal: 20,
            width: "70%",
            fontSize: 19,
            textAlign: "center",
            alignSelf: "center",
          }}
          color="transparent"
          textColor="white"
        >
          {"Filing for Immigration? Know forehand if you qualify!"}
        </AppText>
        <AppText
          style={{
            width: "70%",
            textAlign: "center",
            alignSelf: "center",
            fontSize: 19,
            fontWeight: "bold",
            marginBottom: 20,
          }}
          color="transparent"
          textColor="white"
        >
          {"Quickest way on the internet to verify your Score."}
        </AppText>
      </View>
      <TouchableOpacity
        style={[styles.button, { backgroundColor: colors.yellow }]}
        onPress={onNewReport}
      >
        <Text style={[styles.infoText, { color: "#000" }]}>
          Check Your Score
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.button, { backgroundColor: colors.primary }]}
        onPress={onPreviousReports}
      >
        <Text style={[styles.infoText, { color: "#fff" }]}>
          Access Previous Reports
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.button, { backgroundColor: "rgb(38, 156, 211)" }]}
        onPress={onEditProfile}
      >
        <Text style={[styles.infoText, { color: "#fff" }]}>Edit Profile</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={[
          styles.button,
          { backgroundColor: colors.white, marginBottom: 80 },
        ]}
        onPress={onLogout}
      >
        <Text style={[styles.infoText, { color: "#000" }]}>Logout</Text>
      </TouchableOpacity>
      <View style={{ bottom: 0, position: "absolute" }}>
        <CommonFooter navigation={navigation} />
      </View>
    </Screen>
  );
}

const styles = StyleSheet.create({
  button: {
    borderRadius: 4,
    padding: 10,
    width:
      window.innerWidth <= 760
        ? 0.7 * Dimensions.get("window").width
        : 0.3 * Dimensions.get("window").width,
    flexDirection: "row",
    height: "7%",
    marginHorizontal: 20,
    marginVertical: 10,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
  },
  infoText: {
    fontWeight: "500",
    color: "#FFF",
    textAlign: "center",
  },
});

export default HomeScreen;
